import { getApp, getApps, initializeApp, type FirebaseApp } from "firebase/app";
import { connectAuthEmulator, getAuth, type Auth } from "firebase/auth";
import { connectFunctionsEmulator, getFunctions, type Functions } from "firebase/functions";
import { getStorage, type FirebaseStorage } from "firebase/storage";
import { readFirebaseClientSettings } from "@kajikajy/shared/firebase-web-config";

declare global {
  var __kajikajyAdminEmulatorsConnected: boolean | undefined;
}

export const firebaseClientSettings = readFirebaseClientSettings(import.meta.env, {
  devDefault: import.meta.env.DEV
});

export interface KajikajyAdminFirebaseClient {
  readonly app: FirebaseApp;
  readonly auth: Auth;
  readonly functions: Functions;
  readonly storage: FirebaseStorage;
}

export function getKajikajyAdminFirebaseClient(): KajikajyAdminFirebaseClient | null {
  if (!firebaseClientSettings.config) {
    return null;
  }
  const app = getApps().length > 0 ? getApp() : initializeApp(firebaseClientSettings.config);
  const auth = getAuth(app);
  const functions = getFunctions(app, firebaseClientSettings.emulator.functionsRegion);
  const storage = getStorage(app);

  if (firebaseClientSettings.useEmulators && !globalThis.__kajikajyAdminEmulatorsConnected) {
    connectAuthEmulator(
      auth,
      `http://${firebaseClientSettings.emulator.authHost}:${firebaseClientSettings.emulator.authPort}`,
      { disableWarnings: true }
    );
    connectFunctionsEmulator(
      functions,
      firebaseClientSettings.emulator.functionsHost,
      firebaseClientSettings.emulator.functionsPort
    );
    globalThis.__kajikajyAdminEmulatorsConnected = true;
  }

  return { app, auth, functions, storage };
}
